import React from 'react';
import { Icon, Table } from 'semantic-ui-react';
import moment from 'moment';
import { defaultDateFormatJustDate, defaultDateFormatJustTime } from '../../../../Dates';

const DateFormattedCell = ({
  rowValues,
  entryRecord,
  index = 0,
  negativeCell = false,
  positiveCell = false,
  disableBorder = false,
  showTime = true,
}) => {
  let readableValue,
    readableTime = '';
  let dateValue = rowValues[entryRecord.key];
  if (dateValue !== 'null') {
    let date = new Date(dateValue);
    if (moment(date).year() !== 9999) {
      readableValue = moment(date).format(defaultDateFormatJustDate);
      readableTime = moment(new Date(dateValue)).format(defaultDateFormatJustTime);
    }
  }

  return (
    <Table.Cell
      key={rowValues.ID + index}
      className="tableCell tableCellReducedPadding2"
      positive={positiveCell}
      negative={negativeCell}
      style={{ padding: '0px', ...(disableBorder && { borderTopWidth: '0px' }) }}
    >
      {readableValue && (
        <>
          <Icon name="calendar alternate outline" style={{ color: '#cccccc' }} />
          {readableValue}
        </>
      )}
      {showTime && readableTime && (
        <>
          <br />
          <Icon name="clock outline" style={{ color: '#cccccc' }} />
          {readableTime}
        </>
      )}
    </Table.Cell>
  );
};

export default DateFormattedCell;
